import React, { useState, useEffect } from 'react';
import api from '../api/api';
import { useAuth } from '../context/AuthContext';
import { pdf } from '@react-pdf/renderer';
import ExportPDFAuthorisationEAFdw from './ExportPDFAuthorisationEAFdw';
// eslint-disable-next-line react/prop-types
const AuthorisationEAFdw = ({ booking_id }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    employerName: '',
    employerNric: '',
    employerContact: '',
    employerSignature: '',
    fdw1Name: '',
    fdw1Id: '',
    fdw1Txn: '',
    fdw2Name: '',
    fdw2Id: '',
    fdw2Txn: '',
    eaNameLicence: '',
    repName: '',
    repId: '',
    eaPersonnel: '',
    eaRegNo: '',
    eaSignature: ''
  });

  const [result, setResult] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
const [agencyInfo, setAgencyInfo] = useState({});
  // Fetch existing authorization data
  const fetchAuthorizationData = async () => {
    if (!booking_id) return;
    
    setIsLoading(true);
    try {
      const response = await api.get(`external-forms/authorisation-ea-fdw/${booking_id}/`);
      if (response.data) {
          setAgencyInfo({
          agencyAddress: response.data.agency_address || '',
          agencyPhone: response.data.agency_phone || ''
        });
        setFormData({
          employerName: response.data.employer_name || '',
          employerNric: response.data.employer_nric || '',
          employerContact: response.data.employer_contact || '',
          employerSignature: response.data.employer_signature || '',
          fdw1Name: response.data.fdw1_name || '',
          fdw1Id: response.data.fdw1_id || '',
          fdw1Txn: response.data.fdw1_txn || '',
          fdw2Name: response.data.fdw2_name || '',
          fdw2Id: response.data.fdw2_id || '',
          fdw2Txn: response.data.fdw2_txn || '',
          eaNameLicence: response.data.ea_name_licence || '',
          repName: response.data.rep_name || '',
          repId: response.data.rep_id || '',
          eaPersonnel: response.data.ea_personnel || '',
          eaRegNo: response.data.ea_reg_no || '',
          eaSignature: response.data.ea_signature || ''
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log('No existing authorization found for booking_id:', booking_id);
      } else {
        console.error('Error fetching authorization data:', error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAuthorizationData();
  }, [booking_id]);

  const validateForm = () => {
    const newErrors = {};
    // Add validation rules here if needed
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setErrors({});
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const submitData = {
        booking: booking_id,
        employer_name: formData.employerName,
        employer_nric: formData.employerNric,
        employer_contact: formData.employerContact,
        employer_signature: formData.employerSignature,
        fdw1_name: formData.fdw1Name,
        fdw1_id: formData.fdw1Id,
        fdw1_txn: formData.fdw1Txn,
        fdw2_name: formData.fdw2Name,
        fdw2_id: formData.fdw2Id,
        fdw2_txn: formData.fdw2Txn,
        ea_name_licence: formData.eaNameLicence,
        rep_name: formData.repName,
        rep_id: formData.repId,
        ea_personnel: formData.eaPersonnel,
        ea_reg_no: formData.eaRegNo,
        ea_signature: formData.eaSignature
      };

      const response = await api.post(`external-forms/authorisation-ea-fdw/${booking_id}/`, submitData);
      console.log('Authorization submitted successfully:', response.data);
      alert('Authorization form submitted successfully!');
      
    } catch (error) {
      console.error('Error submitting authorization:', error);
      if (error.response?.data) {
        if (typeof error.response.data === 'object') {
          setErrors(error.response.data);
        } else {
          alert('Error submitting form: ' + error.response.data);
        }
      } else {
        alert('Error submitting form. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitForm = () => {
    setResult("Captured JSON: " + JSON.stringify(formData, null, 2));
  };

  const resetForm = () => {
    setFormData({
      employerName: '',
      employerNric: '',
      employerContact: '',
      employerSignature: '',
      fdw1Name: '',
      fdw1Id: '',
      fdw1Txn: '',
      fdw2Name: '',
      fdw2Id: '',
      fdw2Txn: '',
      eaNameLicence: '',
      repName: '',
      repId: '',
      eaPersonnel: '',
      eaRegNo: '',
      eaSignature: ''
    });
    setResult('');
  };

  const handleDelete = async () => {
    if (!booking_id) {
      alert('No booking ID provided for deletion');
      return;
    }

    const confirmDelete = window.confirm(
      'Are you sure you want to delete this Authorisation EA FDW record? This action cannot be undone.'
    );

    if (!confirmDelete) {
      return;
    }

    setIsSubmitting(true);

    try {
      console.log('Deleting Authorisation EA FDW for booking_id:', booking_id);
      const response = await api.delete(`external-forms/authorisation-ea-fdw/${booking_id}/`);
      console.log('Authorisation EA FDW deleted successfully:', response.data);
      
      // Show success message
      alert('Authorisation EA FDW record deleted successfully!');
      
      // Reset the form after deletion
      resetForm();
      
    } catch (error) {
      console.error('Error deleting Authorisation EA FDW:', error);
      alert('Authorisation EA FDW record deleted successfully!');
    } finally {
      setIsSubmitting(false);
    }
  };

  const { user } = useAuth();
  const handleDownloadPDF = async () => {
    setIsSubmitting(true);

    try {
      console.log('Generating Authorisation EA FDW PDF for booking_id:', booking_id);
      
      // Prepare the data for PDF generation
      const pdfData = {
        ...formData,
        booking_id: booking_id
      };

      // Generate PDF using React PDF
      const blob = await pdf(
        <ExportPDFAuthorisationEAFdw
          user={user}
          data={pdfData}
          agencyInfo={agencyInfo}
        />
      ).toBlob();
      
      // Create blob link to download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Generate filename with current date
      const today = new Date().toISOString().split('T')[0];
      const filename = booking_id 
        ? `Authorisation_EA_FDW_${booking_id}_${today}.pdf`
        : `Authorisation_EA_FDW_${today}.pdf`;
      link.setAttribute('download', filename);
      
      // Append to html link element page
      document.body.appendChild(link);
      
      // Start download
      link.click();
      
      // Clean up and remove the link
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log('Authorisation EA FDW PDF generated and downloaded successfully');
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="page-wrapper" style={{ marginLeft: '0' }}>
        <div className="content container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="content-page-header">
                    <h5>Authorisation for EA for FDW</h5>
                  </div>
                  <p className="text-muted small mb-3">Converted from your Word document. (Source: Authorisation for EA for FDW.docx)</p>

                  {/* Loading Indicator */}
                  {isLoading && (
                    <div className="d-flex justify-content-center align-items-center py-5">
                      <div className="spinner-border text-primary me-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <span className="text-muted">Loading existing authorization data...</span>
                    </div>
                  )}

                  {/* Form Content - Hidden during loading */}
                  <div style={{ display: isLoading ? 'none' : 'block' }}>
                  <form onSubmit={handleSubmit}>
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Declaration by Employer</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Employer Name</label>
                              <input 
                                type="text" 
                                name="employerName"
                                value={formData.employerName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>NRIC / FIN</label>
                              <input 
                                type="text" 
                                name="employerNric"
                                value={formData.employerNric}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="input-block mb-3">
                          <label>Contact No.</label>
                          <input 
                            type="text" 
                            name="employerContact"
                            value={formData.employerContact}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="input-block mb-3">
                          <label>Signature & Date</label>
                          <input 
                            type="text" 
                            name="employerSignature"
                            value={formData.employerSignature}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Foreign Domestic Worker(s)</h6>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>S/N</th>
                                <th>Name of FDW</th>
                                <th>Passport / FIN / WP No.</th>
                                <th>Authorised Transaction</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>1</td>
                                <td>
                                  <input 
                                    type="text" 
                                    name="fdw1Name"
                                    value={formData.fdw1Name}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                  />
                                </td>
                                <td>
                                  <input 
                                    type="text" 
                                    name="fdw1Id" 
                                    value={formData.fdw1Id}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                  />
                                </td>
                                <td>
                                  <input 
                                    type="text" 
                                    name="fdw1Txn"
                                    value={formData.fdw1Txn}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>2</td>
                                <td>
                                  <input 
                                    type="text" 
                                    name="fdw2Name"
                                    value={formData.fdw2Name}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                  />
                                </td>
                                <td>
                                  <input 
                                    type="text" 
                                    name="fdw2Id"
                                    value={formData.fdw2Id}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                  />
                                </td>
                                <td>
                                  <input 
                                    type="text" 
                                    name="fdw2Txn"
                                    value={formData.fdw2Txn}
                                    onChange={handleInputChange}
                                    className="form-control form-control-sm"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Authorisation of EA</h6>
                      </div>
                      <div className="card-body">
                        <div className="input-block mb-3">
                          <label>I hereby authorise</label>
                          <input 
                            type="text" 
                            name="eaNameLicence" 
                            placeholder="Name and licence no. of EA"
                            value={formData.eaNameLicence}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                          <small className="text-muted">to perform the above work pass transaction(s) on my behalf.</small>
                        </div>

                        <div className="input-block mb-3">
                          <label>If applicable, I hereby authorise</label>
                          <input 
                            type="text" 
                            name="repName" 
                            placeholder="Representative Full Name (as in NRIC/Passport)"
                            value={formData.repName}
                            onChange={handleInputChange}
                            className="form-control mb-2"
                          />
                          <input 
                            type="text" 
                            name="repId" 
                            placeholder="Representative NRIC/Passport No."
                            value={formData.repId}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                          <small className="text-muted">A copy of the representative&apos;s NRIC/Passport must be enclosed.</small>
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Declaration by EA</h6>
                      </div>
                      <div className="card-body">
                        <div className="input-block mb-3">
                          <label>Name of EA Personnel</label>
                          <input 
                            type="text" 
                            name="eaPersonnel"
                            value={formData.eaPersonnel}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="input-block mb-3">
                          <label>Registration No.</label>
                          <input 
                            type="text" 
                            name="eaRegNo"
                            value={formData.eaRegNo}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <div className="input-block mb-3">
                          <label>Signature & Date</label>
                          <input 
                            type="text" 
                            name="eaSignature"
                            value={formData.eaSignature}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                        <p className="text-muted small">I declare that I have verified the authorisation with the employer, confirmed any representative, and ensured all required fields are completed before processing.</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="btn-path text-end">
                          <button type="button" className="btn btn-cancel bg-primary-light me-3" onClick={resetForm} disabled={isSubmitting}>
                            Reset
                          </button>
                          <button
                            type="button"
                            onClick={handleDelete}
                            className="btn btn-danger me-3"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Deleting...' : 'Clean'}
                          </button>
                          <button
                            type="button"
                            onClick={handleDownloadPDF}
                            className="btn btn-success me-3"
                            disabled={isSubmitting}
                            title="Download PDF of current form data"
                          >
                            {isSubmitting ? 'Generating...' : (
                              <>
                                <i className="fas fa-download me-2"></i>
                                Download PDF
                              </>
                            )}
                          </button>
                          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                          </button>
                        </div>
                      </div>
                    </div>
                    {errors.general && (
                      <div className="alert alert-danger mt-3">{errors.general}</div>
                    )}
                  </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthorisationEAFdw;